module.exports = __webpack_public_path__ + "static/img/h1.99be223.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h1.jpg
// module id = kshr
// module chunks = 1